import React, { useEffect, useState } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, TableContainer as MUITableContainer } from "@mui/material";
import { motion } from "framer-motion";

const generateOrders = (size, c_price) => {
  return Array.from({ length: size }, () => ({
    price: (c_price + Math.random() * 1).toFixed(2),
    amount: (Math.random() * 5).toFixed(4),
  })).sort((a, b) => b.price - a.price);
};

const OrderBookMobile = (props) => {
const {price} = props;
  const [bids, setBids] = useState(generateOrders(10, price));
  const [asks, setAsks] = useState(generateOrders(10, price));

  useEffect(() => {
    const interval = setInterval(() => {
      setBids(generateOrders(10, price));
      setAsks(generateOrders(10, price));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box>
      

      <Box sx={{  gap: 0, mt: 0, position: "relative", width: "100%" }}>
        <TableContainer title="Asks" data={asks} color="red" direction="left" />
      </Box>

      <Box sx={{  gap: 0, mt: 0, position: "relative", width: "100%" }}>
        <TableContainer title="Bids" data={bids} color="green" direction="left" />
      </Box>
      
    </Box>
  );
};

const TableContainer = ({ title, data, color, direction }) => {
  const maxAmount = Math.max(...data.map((order) => parseFloat(order.amount)));

  return (
    <Box sx={{
      position: "relative",
      overflow: "hidden",
      width: "100%",
      animation: `moveBackground 5s linear infinite`,
      animationDirection: direction === "left" ? "normal" : "reverse",
      borderRadius: 0,
      fontFamily: 'Inter, sans-serif',
    }}>
      <Typography variant="subtitle1" sx={{ color, fontWeight: 700, fontFamily: 'Inter, sans-serif', fontSize: '12px', mb: 0.5 }}>{title}</Typography>
      {title === 'Bids' ?
        <MUITableContainer sx={{maxHeight: 'none', border: 'none', borderRadius: 0}}>
          <Table size="small" sx={{ position: "relative", border: 'none', borderRadius: 0 }}>
            <TableHead>
              <TableRow sx={{ borderBottom: "none", borderRadius: 0 }}>
                <TableCell sx={{borderBottom: "none", borderRadius: 0, fontFamily: 'Inter, sans-serif', fontSize: '11px', color: '#B7BDC6', fontWeight: 600}}>Qty</TableCell>
                <TableCell sx={{borderBottom: "none", borderRadius: 0, fontFamily: 'Inter, sans-serif', fontSize: '11px', color: '#B7BDC6', fontWeight: 600}}>Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{border: 'none'}}>
              {data.map((order, index) => (
                <motion.tr
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                  style={{ position: "relative" }}
                >
                  <TableCell sx={{borderBottom: "none", fontSize: '10px', padding: '2px 4px', color: '#848E9C', fontWeight: 400, fontFamily: 'Inter, sans-serif', background: 'none', borderRadius: 0}}>{order.amount}</TableCell>
                  <TableCell sx={{ position: "relative", padding: '2px 4px', borderBottom: "none", borderRadius: 0 }}>
                    <Box sx={{ position: "relative", fontSize: '11px', color: '#38ba38', fontWeight: 700, fontFamily: 'Inter, sans-serif' }}>
                      {order.price}
                    </Box>
                  </TableCell>
                  {title === 'Bids' &&
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        width: `${(parseFloat(order.amount) / maxAmount) * 100}%`,
                        height: "100%",
                        backgroundColor: color,
                        opacity: 0.12,
                        transition: "width 0.5s ease-in-out",
                        borderRadius: 0,
                      }}
                    />
                  }
                </motion.tr>
              ))}
            </TableBody>
          </Table>
        </MUITableContainer>
      :
        <MUITableContainer sx={{maxHeight: 'none', border: 'none', borderRadius: 0}}>
          <Table size="small" sx={{ position: "relative", border: 'none', borderRadius: 0 }}>
            <TableHead>
              <TableRow  sx={{ borderBottom: "none", borderRadius: 0 }}>
                <TableCell sx={{borderBottom: "none", borderRadius: 0, fontFamily: 'Inter, sans-serif', fontSize: '11px', color: '#B7BDC6', fontWeight: 600}}>Price</TableCell>
                <TableCell sx={{borderBottom: "none", borderRadius: 0, fontFamily: 'Inter, sans-serif', fontSize: '11px', color: '#B7BDC6', fontWeight: 600}}>Qty</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{border: 'none'}}>
              {data.map((order, index) => (
                <motion.tr
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                  style={{ position: "relative" }}
                  whileHover={{ backgroundColor: '#f9fafb' }}
                >
                  <TableCell sx={{ position: "relative", padding: '2px 4px', borderBottom: "none", borderRadius: 0 }}>
                    <Box sx={{ position: "relative", padding: "1px", fontSize: '11px', color: '#f52f2f', fontWeight: 700, fontFamily: 'Inter, sans-serif' }}>{order.price}</Box>
                  </TableCell>
                  <TableCell sx={{borderBottom: "none", padding: '2px 4px', fontSize: '10px', color: '#848E9C', fontWeight: 400, fontFamily: 'Inter, sans-serif', background: 'none', borderRadius: 0}}>{order.amount}</TableCell>
                  {title === 'Asks' &&
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        width: `${(parseFloat(order.amount) / maxAmount) * 100}%`,
                        height: "100%",
                        backgroundColor: color,
                        opacity: 0.12,
                        transition: "width 0.5s ease-in-out",
                        borderRadius: 0,
                      }}
                    />
                  }
                </motion.tr>
              ))}
            </TableBody>
          </Table>
        </MUITableContainer>
      }
    </Box>
  );
};

export default OrderBookMobile;
